import { FC, ReactNode, useState } from 'react';
import { IconInformation } from '../../../../../../../assets/DesignSystem/SVGComponents';
import { NudosSearchbarDropdown } from '../../../../../../../components/NudosComponents';
import { DeleteModalTag, TagsOptions } from './Components';
import { CloseIcon } from '../../../../../../../assets/images/bussines';
import { IorganizationBusinessData, ITags } from '../../../../../../../types/bussines';
import { createTag, deleteTag, assignTag, deleteTagOrganziation } from '../../../../../../../services/bussines';
import { displayErrorNotification } from '../../../../../../../utils/displayNudosStandardNotifications';
import { LoadingOutlined } from '@ant-design/icons';

import './TagFiltering.scss';

interface IAlertInfo {
  infoDetails: ReactNode;
  textFirstButton: string;
  textSecondButton: string;
  closeModal: () => void;
  secondButtonAction: () => void;
}

interface ITagFiltering {
  organizationData: IorganizationBusinessData;
  updateWithoutLoaders: () => void;
}

const TagFiltering: FC<ITagFiltering> = ({ organizationData, updateWithoutLoaders }: ITagFiltering) => {
  const [openModalDeleteTagInList, setOpenModalDeleteTagInList] = useState<IAlertInfo>();
  const [loaderSearchBar, setLoaderSearchBar] = useState<boolean>(false);
  const [loaderRemoveTag, setLoaderRemoveTag] = useState<boolean>(false);
  const [loaderAddOrganization, setLoaderAddOrganization] = useState<boolean>(false);
  const listOfAssignedTags = [...(organizationData.assignedTags || [])];
  const uniqueTags = listOfAssignedTags.filter((obj, index, self) => self.findIndex(o => o.id === obj.id) === index);

  const closeModal = () => {
    setOpenModalDeleteTagInList(undefined);
  };
  const addTagsListOrganization = async (tag: ITags) => {
    await assignTagToACompany(tag);
  };

  const removeTagInList = async (tag: ITags) => {
    if (!tag?.uuid) return;
    setLoaderRemoveTag(true);
    try {
      await deleteTag(tag.uuid);
      await updateWithoutLoaders();
      closeModal();
    } catch (error) {
      displayErrorNotification();
    } finally {
      setLoaderRemoveTag(false);
    }
  };

  const removeTagFromOrganization = async (tag: ITags) => {
    if (!tag?.uuid) return;
    setLoaderRemoveTag(true);
    try {
      await deleteTagOrganziation({ organizationId: organizationData.id, organizationsTagId: tag.id });
      await updateWithoutLoaders();
      closeModal();
    } catch (error) {
      displayErrorNotification();
    } finally {
      setLoaderRemoveTag(false);
    }
  };

  const addTagAndAddToList = async (searchString: string, clickOptionCallback?: (option: ITags) => void) => {
    if (!searchString) return;
    setLoaderSearchBar(true);
    try {
      const dataTag = await createTag({ name: searchString?.trim() });
      await assignTag({ organizationId: organizationData.id, organizationsTagsIds: [dataTag.id] });
      await updateWithoutLoaders();
      clickOptionCallback && clickOptionCallback(dataTag);
    } catch {
      displayErrorNotification();
    } finally {
      setLoaderSearchBar(false);
    }
  };

  const removeTagInListOpenModal = (tag: ITags) => {
    const deleteTagSelectList: IAlertInfo = {
      infoDetails: (
        <div className="deleteTagSelectList">
          <div className="titleDeteleTagList">
            Estás a punto de eliminar el atributo <strong> {tag.name}</strong>
          </div>
          <div className="subTitleDeteleTagList">
            Si lo eliminas, se eliminará a todas las empresas que lo
            <br /> tengan aplicado y no podrás recuperarlo nuevamente, <br />
            ¿seguro que deseas continuar?
          </div>
        </div>
      ),
      textFirstButton: 'No, mantener',
      textSecondButton: 'Sí, eliminar etiqueta',
      closeModal: closeModal,
      secondButtonAction: () => removeTagInList(tag)
    };
    setOpenModalDeleteTagInList(deleteTagSelectList);
  };

  const deleteOrganizationTag = (tag: ITags) => {
    const deleteTagSelectList: IAlertInfo = {
      infoDetails: (
        <div className="deleteTagSelectList">
          <div className="titleDeteleTagList">
            Estás a punto de quitar el atributo <strong> {tag.name}</strong> a la empresa{' '}
            <strong>
              <br />
              {organizationData.name}
            </strong>{' '}
          </div>
          <div className="subTitleDeteleTagList">
            No te preocupes, podrás agregarla nuevamente cuando lo
            <br /> necesites
          </div>
        </div>
      ),
      textFirstButton: 'No, mantener',
      textSecondButton: 'Sí, quitar etiqueta',
      closeModal: closeModal,
      secondButtonAction: () => removeTagFromOrganization(tag)
    };
    setOpenModalDeleteTagInList(deleteTagSelectList);
  };

  const assignTagToACompany = async (tag: ITags) => {
    setLoaderAddOrganization(true);
    try {
      await assignTag({ organizationId: organizationData.id, organizationsTagsIds: [tag.id] });
      await updateWithoutLoaders();
    } catch (error) {
      displayErrorNotification();
    } finally {
      setLoaderAddOrganization(false);
    }
  };

  const formDropdownOptionsCallback = (
    rawOptions: ITags[],
    clickOptionCallback?: (option: ITags) => void,
    searchString?: string
  ) => {
    if (rawOptions.length === 0) {
      return [
        <div className="tagsNoResults">
          <div className="addSearchText"> {searchString} - </div>
          <div
            className="addSearchTextOrange"
            onClick={() => {
              if (searchString) {
                addTagAndAddToList(searchString, clickOptionCallback);
              }
            }}
          >
            &#160;Nuevo
          </div>
        </div>
      ];
    }

    return rawOptions.map((option, i) => {
      const handleSelectOption = () => {
        addTagsListOrganization(option);
      };

      const selectedItem = organizationData.assignedTags?.find(tag => tag.id === option.id);

      return (
        <TagsOptions
          tagOption={option}
          selectedItem={!!selectedItem}
          deleteOrganizationTag={deleteOrganizationTag}
          handleSelectOption={handleSelectOption}
          removeTagInListOpenModal={removeTagInListOpenModal}
        />
      );
    });
  };

  const formSelectedOptionUICallback = (rawSelectedOption: ITags) => {
    return <div className="selectedOption">{rawSelectedOption?.name}</div>;
  };

  const filterBySearchStringCallback = (search: string, rawOptions: ITags[]) => {
    return rawOptions.filter(taxData => taxData?.name?.toLowerCase().trim().includes(search.toLowerCase().trim()));
  };

  return (
    <>
      {openModalDeleteTagInList && <DeleteModalTag alertInfo={openModalDeleteTagInList} loader={loaderRemoveTag} />}{' '}
      <div id="tagFiltering">
        <div className="titleTags">Etiquetas de la empresa</div>
        <div className="alertTagsContainer">
          <div className="alertIconContainerTags">
            <IconInformation />
          </div>
          Los etiquetas te permiten filtrar y categorizar las empresas
        </div>
        <div className="dropDownTagsContainer">
          <NudosSearchbarDropdown
            componentSize="large"
            customPlaceholder="Selecciona las etiquetas"
            rawOptions={organizationData?.availableTags || []}
            formDropdownOptionsCallback={formDropdownOptionsCallback}
            formSelectedOptionUICallback={formSelectedOptionUICallback}
            filterBySearchStringCallback={filterBySearchStringCallback}
            includeMagnifierIcon={false}
            showSkeletonLoader={loaderSearchBar}
          />
        </div>
        {loaderAddOrganization && (
          <div className="loaderCenter">
            <div className="loaderCenterTitle" />
            <div className="genericCenterItem">
              <LoadingOutlined style={{ color: '#070F21', fontSize: '20px' }} />
            </div>
          </div>
        )}
        {!loaderAddOrganization && uniqueTags && uniqueTags?.length > 0 && (
          <div className="organizationTagsContainer">
            <div className="titleOrganizationTags">Etiquetas seleccionadas</div>
            <div className="itemsTagContainer">
              {uniqueTags?.map((item, index) => {
                return (
                  <div
                    className="itemTagOrganization"
                    key={`item-tag-${item.id}-index-${index}`}
                    onClick={() => {
                      deleteOrganizationTag(item);
                    }}
                  >
                    {item.name}
                    <div className="deleteIconTagContainer">
                      <CloseIcon className="iconXTagStyle" />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default TagFiltering;
